module.exports = __webpack_public_path__ + "static/media/project-lettermorphing.f16524e9.png";